import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { APP_PATHS, SEARCH_DEVICES_TABLE_COLUMNS_CONFIG } from '@core/constants';
import { DeviceModel } from '@core/models';
import { TableComponent } from '@custom-components/general/table/table.component';

@Component({
  selector: 'xemex-devices-content',
  imports: [TableComponent],
  templateUrl: './devices-content.component.html',
  styleUrl: './devices-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevicesContentComponent {
  devices = input<DeviceModel[]>([]);
  loading = input(false);

  protected readonly columns = SEARCH_DEVICES_TABLE_COLUMNS_CONFIG;

  protected readonly tableData = computed(
    () => this.devices() as unknown as Record<string, unknown>[],
  );

  protected readonly rowLink = (row: Record<string, unknown>) => [
    '/',
    APP_PATHS.Devices,
    row['deviceId'] as string,
  ];
}
